module.exports = __webpack_public_path__ + "img/onsen3.a4e31618.jpg";